// src/components/CtaDevis.js
import React from "react";
import { trackEvent } from "../analytics/ga";

export default function CtaDevis() {
  const subject = "Demande de devis – HLBK";
  const body = `
Bonjour,

Je souhaite un devis pour :

- Type : Portrait / Mariage / Événement / Entreprise
- Lieu du shooting :
- Date(s) souhaitée(s) :
- Usage des photos (web, réseaux, print…) :
- Détails utiles (style, ambiance, contraintes horaires…) :

Mes coordonnées :

- Nom / Société :
- Téléphone :
- Site / Instagram :

Merci !
  `.trim();

  const href = `mailto:contact@hlbk.fr?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <div
      className="cta-devis-wrap"
      role="complementary"
      aria-label="Appel à l’action"
    >
      <a
        className="cta-devis-btn"
        href={href}
        onClick={() =>
          trackEvent({
            action: "cta_devis_click",
            category: "cta",
            label: "global", // tu peux changer selon l’emplacement : header/footer/services…
          })
        }
      >
      </a>
    </div>
  );
}